<template>
  <el-container>
    <el-header>
      <myHeader></myHeader>
    </el-header>
    <el-main>
      <div class="table-global mar-bottom-10 pad-bottom-0">
        <el-form :inline="true" :model="form" @submit.native.prevent>
          <el-row type="flex">
            <el-col :span="12" style="text-align: left">
              <el-form-item label="">
                <el-input
                  v-model="form.yhmc"
                  style="width: 400px"
                  placeholder="请输入考生名称"
                  @keyup.enter.native="query()"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="query()" id="query">
                  查询
                </el-button>
                <el-button type="text" @click="clearHandle()"
                  >高级筛选</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="12" style="text-align: right">
              <el-form-item>
                <el-button
                  type="primary"
                  style="color: white"
                  @click="handleAdd"
                >
                  <i class="el-icon-plus">&emsp;新增</i>
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="color: white"
                  @click="dialogVisible = true"
                >
                  批量导入
                </el-button>
                <el-dialog
                  title="考生导入"
                  :visible.sync="dialogVisible"
                  width="50%"
                  style="text-align: left"
                >
                  <div style="margin-top: -60px">
                    <el-divider></el-divider>
                  </div>
                  <div style="margin: 30px 0px 50px 30px">
                    <div>
                      <span>第一步、下载导入模板</span>
                    </div>
                    <div>
                      <el-form-item>
                        <el-button
                          class="button_color"
                          size="mini"
                          @click="simpleExcel"
                        >
                          简单模板（点击下载）
                        </el-button>
                      </el-form-item>
                      <el-form-item>
                        <el-button
                          class="button_color"
                          size="mini"
                          @click="complexExcel"
                        >
                          完整模板（点击下载）
                        </el-button>
                      </el-form-item>
                    </div>
                    <div>
                      <span>第二步、上传导入文件</span>
                    </div>
                    <div>
                      <el-select
                        placeholder="请选择模板类型"
                        size="small"
                        v-model="mblx"
                        style="width: 100px; margin-right: 5px"
                      >
                        <el-option label="简单模板" value="simple"></el-option>
                        <el-option label="完整模板" value="comple"></el-option>
                      </el-select>
                      <el-form-item prop="file">
                        <el-upload
                          ref="upload"
                          :limit="1"
                          :auto-upload="false"
                          accept=".xls"
                          name="fileName"
                          action="#"
                          :before-upload="beforeUploadFile"
                          :on-exceed="exceedFile"
                          :on-success="handleSuccess"
                          :on-error="handleError"
                          :file-list="fileList"
                          :http-request="customUpload"
                        >
                          <el-button type="primary" plain size="mini">
                            <i class="el-icon-upload el-icon--right"></i>
                            上传导入文件
                          </el-button>
                        </el-upload>
                      </el-form-item>
                    </div>
                  </div>
                  <div style="margin-bottom: -15px">
                    <div>
                      <span>注：</span>
                    </div>
                    <div style="margin-top: -15px">
                      <span>1、简单模板：账号、姓名、密码</span>
                    </div>
                    <div style="margin-top: -15px">
                      <span
                        >2、完整模板：账号、姓名、密码、邮箱、性别、手机号、身份证、部门、岗位</span
                      >
                    </div>
                  </div>
                  <div style="margin-bottom: -10px">
                    <el-divider></el-divider>
                  </div>
                  <div style="text-align: center">
                    覆盖导入
                    <el-switch
                      style="margin-right: 30px"
                      v-model="fgdr"
                      active-value="yes"
                      inactive-value="no"
                    ></el-switch>
                    <el-button
                      style="margin-right: 20px; width: 100px"
                      size="small"
                      type="primary"
                      @click="uploadFile"
                      >导入</el-button
                    >
                    <el-button
                      style="width: 100px"
                      @click="dialogVisible = false"
                      size="mini"
                      >关闭</el-button
                    >
                  </div>
                </el-dialog>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  style="color: white"
                  @click="handleRemoveAll"
                  id="sc"
                  :disabled="!lshStr.length > 0"
                >
                  批量删除
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="warning"
                  style="color: white"
                  @click="bmgldialogVisible = true"
                >
                  部门管理
                </el-button>
                <el-dialog :visible.sync="bmgldialogVisible" width="40%">
                  <div class="custom-tree-container" style="text-align: left">
                    <div class="block" style="width: 400px">
                      <el-button
                        type="text"
                        @click="add_new_Area"
                        class="button-style"
                        ><i class="el-icon-plus" style="margin-right: 5px"></i
                        >添加</el-button
                      >
                      <el-tree
                        :data="bmdata"
                        show-checkbox
                        node-key="bmid"
                        default-expand-all
                        ref="tree"
                        :props="defaultProps"
                        :expand-on-click-node="false"
                        draggable
                        :allow-drop="allowDrop"
                        :allow-drag="allowDrag"
                      >
                        <span
                          class="custom-tree-node"
                          slot-scope="{ node, data }"
                        >
                          <!-- 如果是编辑状态 -->
                          <template v-if="data.isEdit == 1">
                            <el-input
                              ref="input"
                              @blur="() => submitEdit(node, data)"
                              v-model="newApiGroupName"
                              style="height:20px line-height:20px"
                            ></el-input>
                          </template>
                          <!-- 如果不是编辑状态 -->
                          <span v-else v-text="data.bmmc"></span>
                          <span>
                            <el-button
                              type="text"
                              size="mini"
                              @click="() => edit(node, data)"
                            >
                              编辑
                            </el-button>
                            <el-button
                              type="text"
                              size="mini"
                              @click="() => append(node, data)"
                            >
                              添加
                            </el-button>
                            <el-button
                              type="text"
                              size="mini"
                              @click="() => remove(node, data)"
                            >
                              删除
                            </el-button>
                          </span>
                        </span>
                      </el-tree>
                      <el-row
                        class="add_question"
                        v-show="treeSetData.addNodeFlg"
                      >
                        <el-col :span="11" style="margin: 0px 5px">
                          <el-input
                            v-model="treeSetData.bmmc"
                            placeholder=""
                            size="mini"
                          ></el-input>
                        </el-col>
                        <el-col :span="12">
                          <el-button
                            size="mini"
                            type="primary"
                            plain
                            @click.stop="add_area_sure"
                            >确定</el-button
                          >
                          <el-button
                            size="mini"
                            type="warning"
                            plain
                            @click.stop="add_area_cancel"
                            >取消</el-button
                          >
                        </el-col>
                      </el-row>
                    </div>
                    <div style="margin-bottom: -10px">
                      <el-divider></el-divider>
                    </div>
                    <div style="text-align: center">
                      <el-button @click="bmgldialogVisible = false" size="mini"
                        >关闭</el-button
                      >
                    </div>
                  </div>
                </el-dialog>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="warning"
                  style="color: white"
                  @click="gwgldialogVisible = true"
                >
                  岗位管理
                </el-button>
                <el-dialog :visible.sync="gwgldialogVisible" width="40%">
                  <div class="custom-tree-container" style="text-align: left">
                    <div class="block" style="width: 400px">
                      <el-button
                        type="text"
                        @click="add_new_Area1"
                        class="button-style"
                        ><i class="el-icon-plus" style="margin-right: 5px"></i
                        >添加</el-button
                      >
                      <el-tree
                        :data="gwdata"
                        show-checkbox
                        node-key="gwid"
                        default-expand-all
                        ref="tree"
                        :props="defaultProps"
                        :expand-on-click-node="false"
                        draggable
                        :allow-drop="allowDrop1"
                        :allow-drag="allowDrag1"
                      >
                        <span
                          class="custom-tree-node"
                          slot-scope="{ node, data }"
                        >
                          <!-- 如果是编辑状态 -->
                          <template v-if="data.isEdit == 1">
                            <el-input
                              ref="input"
                              @blur="() => submitEdit1(node, data)"
                              v-model="newApiGroupName"
                              style="height:20px line-height:20px"
                            ></el-input>
                          </template>
                          <!-- 如果不是编辑状态 -->
                          <span v-else v-text="data.gwmc"></span>
                          <span>
                            <el-button
                              type="text"
                              size="mini"
                              @click="() => edit1(node, data)"
                            >
                              编辑
                            </el-button>
                            <!-- <el-button type="text"
                          size="mini"
                          @click="() => append1(node,data)">
                          添加
                        </el-button> -->
                            <el-button
                              type="text"
                              size="mini"
                              @click="() => remove1(node, data)"
                            >
                              删除
                            </el-button>
                          </span>
                        </span>
                      </el-tree>
                      <el-row
                        class="add_question"
                        v-show="treeSetData1.addNodeFlg"
                      >
                        <el-col :span="11" style="margin: 0px 5px">
                          <el-input
                            v-model="treeSetData1.gwmc"
                            placeholder=""
                            size="mini"
                          ></el-input>
                        </el-col>
                        <el-col :span="12">
                          <el-button
                            size="mini"
                            type="primary"
                            plain
                            @click.stop="add_area_sure1"
                            >确定</el-button
                          >
                          <el-button
                            size="mini"
                            type="warning"
                            plain
                            @click.stop="add_area_cancel1"
                            >取消</el-button
                          >
                        </el-col>
                      </el-row>
                    </div>
                    <div style="margin-bottom: -10px">
                      <el-divider></el-divider>
                    </div>
                    <div style="text-align: center">
                      <el-button @click="gwgldialogVisible = false" size="mini"
                        >关闭</el-button
                      >
                    </div>
                  </div>
                </el-dialog>
              </el-form-item>
            </el-col>
            <el-dialog
              title="高级筛选"
              :visible.sync="querydialogVisible"
              :close-on-click-modal="true"
              :modal="true"
              :show-close="true"
              :center="true"
              class="gjsx-dialog"
            >
              <el-form
                :inline="true"
                :model="form"
                ref="form"
                label-position="right"
                label-width="80px"
              >
                <div id="" align="center">
                  <el-form-item label="所属部门" class="formItem" prop="bmid">
                    <treeselect
                      style="width: 180px"
                      v-model="form.bmid"
                      :multiple="false"
                      placeholder="请选择"
                      :options="bmdata"
                      :show-count="true"
                      value-consists-of="LEAF_PRIORITY"
                      no-results-text="未搜到任何结果"
                      :clear-on-select="true"
                      :default-expand-level="2"
                      :normalizer="ssbmNormalizer"
                    />
                  </el-form-item>
                </div>
                <div id="" align="center">
                  <el-form-item label="所属岗位" class="formItem" prop="gwid">
                    <treeselect
                      style="width: 180px"
                      v-model="form.gwid"
                      :multiple="false"
                      placeholder="请选择"
                      :options="gwdata"
                      :show-count="true"
                      value-consists-of="LEAF_PRIORITY"
                      no-results-text="未搜到任何结果"
                      :clear-on-select="true"
                      :default-expand-level="2"
                      :normalizer="ssgwNormalizer"
                    />
                  </el-form-item>
                </div>
                <div id="" align="center">
                  <el-form-item label="姓名" class="formItem" prop="yhmc">
                    <el-input
                      v-model="form.yhmc"
                      style="width: 180px"
                      placeholder="请输入考生姓名"
                    ></el-input>
                  </el-form-item>
                </div>
                <div id="" align="center">
                  <el-form-item label="邮箱" class="formItem" prop="email">
                    <el-input
                      v-model="form.email"
                      style="width: 180px"
                      placeholder="请输入考生邮箱"
                    ></el-input>
                  </el-form-item>
                </div>
                <div style="margin-bottom: -10px">
                  <el-divider></el-divider>
                </div>
                <div style="text-align: center">
                  <el-button size="small" type="primary" @click="query()"
                    >确定</el-button
                  >
                  <el-button size="small" @click="clearGjsc()">重置</el-button>
                  <el-button @click="querydialogVisible = false" size="mini"
                    >关闭</el-button
                  >
                </div>
              </el-form>
            </el-dialog>
          </el-row>
        </el-form>
      </div>
      <div class="table-global">
        <el-table
          :data="tableData"
          type="selection"
          style="width: 100%"
          :border="true"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" prop="yhid" />
          <el-table-column label="用户ID" width="0" v-if="show" prop="yhid" />
          <el-table-column label="考号" width="90" prop="yhzh" />
          <el-table-column label="姓名" width="90" prop="yhmc" />
          <el-table-column label="部门ID" width="0" v-if="show" prop="bmid" />
          <el-table-column label="部门" width="140" prop="bmmc" />
          <el-table-column label="手机号" width="120" prop="lxdh" />
          <el-table-column label="邮箱" width="160" prop="email" />
          <el-table-column label="性别" width="60" v-if="show" prop="xbid" />
          <el-table-column label="性别" width="60" prop="xb" />
          <el-table-column label="创建时间" width="140" prop="cjsj" />
          <el-table-column label="状态" width="50" prop="zt" />
          <el-table-column label="岗位ID" width="0" v-if="show" prop="gwid" />
          <el-table-column label="岗位" width="100" prop="gwmc" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleUpdate(scope.$index, scope.row)"
                type="info"
              >
                编辑</el-button
              >
              <el-button
                size="mini"
                @click="handleRemove(scope.$index, scope.row)"
                type="danger"
              >
                删除</el-button
              >
              <!--
              <el-button size="mini" @click="handleksfx(scope.$index, scope.row)" type="primary">
                分析考生</el-button>
              -->
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
      </div>
      <el-dialog
        :title="operation ? '新增' : '编辑'"
        :visible.sync="editDialogVisible"
        width="50%"
        :close-on-click-modal="false"
      >
        <el-form
          :inline="true"
          :model="dataForm"
          ref="dataForm"
          :rules="rules"
          label-position="right"
          label-width="80px"
        >
          <div style="margin: 10px 20px 40px 20px">
            <div>
              <el-form-item label="考号" class="formItem" prop="yhzh">
                <el-input
                  v-model="dataForm.yhzh"
                  style="width: 150px"
                  placeholder="请输入考生考号"
                  v-bind:disabled="diasabledInput"
                ></el-input>
              </el-form-item>
              <el-form-item label="姓名" class="formItem" prop="yhmc">
                <el-input
                  v-model="dataForm.yhmc"
                  style="width: 150px"
                  placeholder="请输入考生姓名"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="所属部门" class="formItem" prop="bmid">
                <el-select
                  v-model="dataForm.bmid"
                  style="width: 150px"
                  ref="selectBmid1"
                  clearable
                  @clear="handleBmClear"
                  placeholder="请选择所属部门"
                >
                  <el-option
                    key="bmid"
                    :value="dataForm.bmid"
                    :label="bmmc"
                    style="height: auto"
                  >
                    <el-tree
                      :data="bmdata"
                      default-expand-all
                      node-key="bmid"
                      ref="tree"
                      highlight-current
                      :props="defaultProps1"
                      @node-click="handleNodeClick1"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属岗位" class="formItem" prop="gwid">
                <el-select
                  v-model="dataForm.gwid"
                  style="width: 150px"
                  ref="selectGwid"
                  clearable
                  @clear="handleGwClear"
                  placeholder="请选择所属岗位"
                >
                  <el-option
                    key="gwid"
                    :value="dataForm.gwid"
                    :label="gwmc"
                    style="height: auto"
                  >
                    <el-tree
                      :data="gwdata"
                      default-expand-all
                      node-key="gwid"
                      ref="tree"
                      highlight-current
                      :props="defaultProps2"
                      @node-click="handleNodeClick2"
                    >
                    </el-tree>
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="邮箱" class="formItem" prop="email">
                <el-input
                  v-model="dataForm.email"
                  style="width: 150px"
                  placeholder="请输入考生邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号" class="formItem" prop="lxdh">
                <el-input
                  v-model="dataForm.lxdh"
                  style="width: 150px"
                  placeholder="请输入考生手机号"
                ></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="性别" class="formItem" prop="xb">
                <el-radio v-model="dataForm.xb" label="1" style="width: 60px">
                  男</el-radio
                >
                <el-radio v-model="dataForm.xb" label="2" style="width: 60px"
                  >女</el-radio
                >
              </el-form-item>
              <el-form-item label="密码" class="formItem" prop="yhmm">
                <el-input
                  v-model="dataForm.yhmm"
                  style="width: 150px"
                  placeholder="重置登录密码"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div style="margin-bottom: -10px">
            <el-divider></el-divider>
          </div>
          <div style="text-align: center">
            <el-button size="small" type="primary" @click="save"
              >保存</el-button
            >
            <el-button @click="editDialogVisible = false" size="mini"
              >关闭</el-button
            >
          </div>
        </el-form>
      </el-dialog>
    </el-main>
  </el-container>
</template>
<script>
import myHeader from '@/components/myHeader'
import { baseURL } from '@/assets/js/config'
import * as user from '@/api/user'
import { getDeptList, getPostList } from '@/api/user'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  data () {
    return {
      value: 1,
      form: {
        yhid: '',
        bmid: null,
        gwid: null,
        yhmc: '',
        email: ''
      }, // 查询表单
      currentPage: 1,
      pageSize: 10,
      totalNum: 0,
      tableData: [],
      show: false, // 隐藏列显示
      dialogVisible: false, // 导入弹出框
      mblx: 'simple', // 文件模板类型
      fgdr: 'no', // 是否覆盖导入
      fileList: [], // excel文件列表
      operation: false, // true:新增, false:编辑
      editDialogVisible: false, // 新增部门编辑弹出框
      bmgldialogVisible: false, // 部门管理弹出框
      gwgldialogVisible: false, // 岗位管理弹出框
      querydialogVisible: false, // 高级筛选弹出框
      diasabledInput: false,
      dataForm: {
        bmid: '',
        gwid: '',
        bmmc: '',
        gwmc: '',
        yhzh: '',
        yhmc: '',
        yhmm: '',
        email: '',
        lxdh: '',
        xb: ''
      }, // 新增表单
      rules: {
        yhzh: [
          { required: true, message: '请输入考生账号', trigger: 'change' },
          {
            pattern: /^[A-Z0-9]{5,8}$/,
            message: '账号只能设置5-8位数字或大写字母',
            trigger: 'change'
          }
        ],
        yhmc: [
          { required: true, message: '请输入考生姓名', trigger: 'change' },
          {
            min: 1,
            max: 200,
            message: '长度在 1 到 200 个字符',
            trigger: 'change'
          }
        ],
        yhmm: [
          { min: 6, max: 12, message: '密码长度设置6-12位', trigger: 'change' },
          {
            pattern: /^[0-9a-zA-Z]+$/,
            message: '密码只能设置数字或字母',
            trigger: 'change'
          }
        ],
        bmid: [
          { pattern: /^[0-9]+$/, message: '请重新选择部门', trigger: 'change' }
        ],
        gwid: [
          { required: false, message: '请选择岗位', trigger: 'change' },
          { pattern: /^[0-9]+$/, message: '请重新选择岗位', trigger: 'change' }
        ],
        email: [
          { required: false, message: '请输入考生邮箱', trigger: 'change' },
          {
            pattern:
              /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: '邮箱格式错误',
            trigger: 'change'
          }
        ],
        lxdh: [
          { required: false, message: '请输入考生手机号码', trigger: 'change' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式错误',
            trigger: 'change'
          }
        ]
      }, // 表单校验规则
      newApiGroupName: '',
      bmmc: '',
      gwmc: '',
      defaultProps: {
        children: 'children',
        bmmc: 'bmmc', // 部门管理
        gwmc: 'gwmc' // 岗位管理
      }, // 树控件后台数据显示
      defaultProps1: {
        children: 'children',
        label: 'bmmc' // 新增部门选择器
      }, // 树控件后台数据显示
      defaultProps2: {
        children: 'children',
        label: 'gwmc' // 新增部门选择器
      }, // 树控件后台数据显示
      data: [], // 部门数据
      bmdata: [], // 部门数据
      gwdata: [], // 岗位数据
      radio: '', // 单选
      lshStr: '', // 批量删除默认多选框未选中
      // 部门树形结构添加一级节点所需数据
      treeSetData: {
        defaultExpandAll: true, // 是否默认展开
        treeData: [], // 树形组件数据集
        // 添加树形数据数组内容
        addList: [],
        // 是否添加flg
        addNodeFlg: false,
        // 默认的id
        defaultId: 2000,
        // 新增的最外层节点名称
        newName: '',
        tree_key: 0,
        pid: 0
      },
      // 岗位树形结构添加一级节点所需数据
      treeSetData1: {
        defaultExpandAll: true, // 是否默认展开
        treeData: [], // 树形组件数据集
        // 添加树形数据数组内容
        addList: [],
        // 是否添加flg
        addNodeFlg: false,
        // 默认的id
        defaultId: 1000,
        // 新增的最外层节点名称
        newName: '',
        tree_key: 0,
        pid: 0
      },
      ssbmNormalizer (node) {
        return {
          id: node.bmid,
          label: node.bmmc
        }
      },
      ssgwNormalizer (node) {
        return {
          id: node.gwid,
          label: node.gwmc
        }
      }
    }
  },
  components: {
    myHeader,
    Treeselect
  },
  methods: {
    // 简单模板下载
    simpleExcel () {
      // 后台数据下载不能用ajqx请求 这里使用原生的js请求
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.open('GET', baseURL + '/user/simpleExcel?', true)
      xmlhttp.setRequestHeader('Authorization', localStorage.getItem('token'))
      xmlhttp.responseType = 'blob'
      // readyState == 4 为请求完成，status == 200为请求成功返回的状态
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          const blob = xmlhttp.response
          const filename = '员工信息（简单模板）.xls'
          const a = document.createElement('a')
          // 创键临时url对象
          const url = URL.createObjectURL(blob)
          a.href = url
          a.download = filename
          a.click()
          // 释放之前创建的URL对象
          window.URL.revokeObjectURL(url)
        }
      }
      xmlhttp.send()
    },
    // 复杂模板下载
    complexExcel () {
      // 后台数据下载不能用ajax请求 这里使用原生的js请求
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.open('GET', baseURL + '/user/complexExcel?', true)
      xmlhttp.setRequestHeader('Authorization', localStorage.getItem('token'))
      xmlhttp.responseType = 'blob'
      // readyState == 4 为请求完成，status == 200为请求成功返回的状态
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          const blob = xmlhttp.response
          const filename = '员工信息（复杂模板）.xls'
          const a = document.createElement('a')
          // 创键临时url对象
          const url = URL.createObjectURL(blob)
          a.href = url
          a.download = filename
          a.click()
          // 释放之前创建的URL对象
          window.URL.revokeObjectURL(url)
        }
      }
      xmlhttp.send()
    },
    // 导入
    // 文件超出个数限制时的钩子
    exceedFile (files, fileList) {
      this.$message.warning('只能选择1个')
    },
    // 上传文件之前的钩子, 参数为上传的文件,若返回 false 或者返回 Promise 且被 reject，则停止上传
    beforeUploadFile (file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xls的文件')
      }
      if (size > 10) {
        this.$message.warning('文件大小不得超过10M')
      }
    },
    // 文件上传成功时的钩子
    handleSuccess (res, file, fileList) {
      this.$message.success('文件上传成功')
    },
    // 文件上传失败时的钩子
    handleError (res, file, fileList) {
      this.$message.error('文件上传失败')
    },
    // 自定义上传方法
    customUpload (obj) {
      const file = obj.file
      const params = new FormData()
      params.append('file', file)
      params.append('mblx', this.mblx)
      params.append('fgdr', this.fgdr)
      // 后台数据下载不能用ajax请求 这里使用原生的js请求
      var xmlhttp = new XMLHttpRequest()
      xmlhttp.open('POST', baseURL + '/user/file', true)
      xmlhttp.setRequestHeader('Authorization', localStorage.getItem('token'))
      xmlhttp.responseType = 'blob'
      // readyState == 4 为请求完成，status == 200为请求成功返回的状态
      const that = this
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
          const blob = xmlhttp.response
          // 如果返回的是json 则说明是成功的
          if (blob.type === 'application/json') {
            blob.text().then(data => {
              const res = JSON.parse(data)
              that.$message.success(res.msg)
              that.dialogVisible = false
              that.fileList.splice(0)
              that.query()
            })
          } else {
            that.$message.error('部分数据导入失败，详情请查看附件')
            const a = document.createElement('a')
            // 创键临时url对象
            const url = URL.createObjectURL(blob)
            a.href = url
            a.download = '错误数据.xls'
            a.click()
            // 释放之前创建的URL对象
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xmlhttp.send(params)
    },
    // 立即上传
    uploadFile () {
      this.$refs.upload.submit()
    },
    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.query(this.currentPage)
    },
    handleCurrentChange (val) {
      this.query(val)
    },
    // 查询
    query (currentPage = 1) {
      this.dialogVisible = false
      this.currentPage = currentPage
      const params = Object.assign(
        { pageNo: this.currentPage, pageSize: this.pageSize },
        this.form
      )
      user.getList(params).then(res => {
        this.$http.callback(res, () => {
          const data = res.data
          this.tableData = data.list
          this.totalNum = data.count
          this.querydialogVisible = false
        })
      })
    },
    // 刷新部门树的数据
    DepttreeQuery () {
      user.getDeptList().then(res => {
        this.$http.callback(res, () => {
          // 生成部门树
          this.parseDeptList(res.data)
        })
      })
    },
    // 刷新岗位树的数据
    PosttreeQuery () {
      user.getPostList().then(res => {
        this.$http.callback(res, () => {
          // 生成岗位树
          this.parsePostList(res.data)
        })
      })
    },
    // 将数据转成部门树形结构
    parseDeptList (deptList) {
      const bmTemp = {}
      const deptTree = {}
      // 数组转 键值对
      deptList.forEach(dept => {
        bmTemp[dept.bmid] = dept
      })
      for (const bmid in bmTemp) {
        const dept = bmTemp[bmid]
        const sjDept = bmTemp[dept.sjbm]
        if (sjDept) {
          if (!sjDept.children) {
            sjDept.children = []
          }
          sjDept.children.push(dept)
        } else {
          deptTree[bmid] = dept
        }
      }
      this.bmdata = Object.keys(deptTree).map(key => deptTree[key])
    },
    // 将数据转成岗位树形结构
    parsePostList (postList) {
      const gwTemp = {}
      const postTree = {}
      // 数组转 键值对
      postList.forEach(post => {
        gwTemp[post.gwid] = post
      })
      for (const gwid in gwTemp) {
        const post = gwTemp[gwid]
        const sjPost = gwTemp[post.sjbm]
        if (sjPost) {
          if (!sjPost.children) {
            sjPost.children = []
          }
          sjPost.children.push(post)
        } else {
          postTree[gwid] = post
        }
      }
      this.gwdata = Object.keys(postTree).map(key => postTree[key])
    },
    // 添加部门一级节点
    add_new_Area () {
      this.treeSetData.addNodeFlg = true
    },
    add_area_cancel () {
      this.treeSetData.addNodeFlg = false
      this.treeSetData.newName = ''
    },
    add_area_sure () {
      const nodeObj = {
        id: this.treeSetData.defaultId++,
        name: this.treeSetData.bmmc,
        isEdit: 0,
        children: [],
        sjbm: 0
      }
      this.treeSetData.treeData.push(nodeObj)
      this.treeSetData.addNodeFlg = false
      this.treeSetData.addList.push(nodeObj)
      const data = Object.assign({
        bmid: nodeObj.id,
        bmmc: nodeObj.name,
        isEdit: nodeObj.isEdit,
        sjbm: nodeObj.sjbm,
        children: nodeObj.children
      })
      this.saveDep(data)
      this.DepttreeQuery()
    },
    allowDrop (draggingNode, dropNode, type) {
      if (dropNode.data.bmid === 1) {
        return false
      } else {
        return true
      }
    },
    allowDrag (draggingNode) {
      // 顶层默认分组不允许拖拽
      if (draggingNode.data.bmid === 1) {
        return false
      } else {
        return true
      }
    },
    // 添加部门
    append (node, data) {
      let bmid = 2000
      const newChild = {
        bmid: bmid++,
        isEdit: 0,
        bmmc: '添加新节点',
        sjbm: data.bmid,
        children: []
      }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(newChild)
      // this.saveDep(newChild)
    },
    // 编辑部门
    edit (node, data) {
      this.$set(data, 'isEdit', 1)
      this.newApiGroupName = data.bmmc
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
      // console.log('after:', data.bmid, data.bmmc, data.isEdit)
    },
    // 判断编辑框是否修改
    submitEdit (node, data) {
      if (data.bmmc === this.newApiGroupName) {
        // console.log('没有修改')
        this.newApiGroupName = ''
        this.$set(data, 'isEdit', 0)
      } else {
        this.$set(data, 'bmmc', this.newApiGroupName)
        this.newApiGroupName = ''
        this.$set(data, 'isEdit', 0)
        this.saveDep(data)
      }
    },
    // 保存编辑后的的部门
    saveDep (data) {
      this.$confirm('确认提交吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = Object.assign({}, data)
        user.saveDep(params).then(res => {
          if (res.code === 200) {
            this.$message({ message: '添加成功', type: 'success' })
          } else {
            this.$message({ message: '操作失败, ' + res.msg, type: 'error' })
          }
          this.DepttreeQuery()
        })
      })
    },
    // 删除部门
    remove (node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.bmid === data.bmid)
      children.splice(index, 1)
      this.removeDep(data)
    },
    removeDep (data) {
      this.$confirm('确定需要删除选中部门吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          bmid: data.bmid
        }
        user.removeDep(params).then(res => {
          if (res.code === 200) {
            this.$message({ message: '删除成功', type: 'success' })
          } else {
            this.$message({ message: '操作失败, ' + res.msg, type: 'error' })
          }
          this.DepttreeQuery()
        })
      })
    },
    // 添加岗位一级节点
    add_new_Area1 () {
      this.treeSetData1.addNodeFlg = true
    },
    add_area_cancel1 () {
      this.treeSetData1.addNodeFlg = false
      this.treeSetData1.newName = ''
    },
    add_area_sure1 () {
      const nodeObj = {
        id: this.treeSetData1.defaultId++,
        name: this.treeSetData1.gwmc,
        isEdit: 0,
        children: []
      }
      this.treeSetData1.treeData.push(nodeObj)
      this.treeSetData1.addNodeFlg = false
      this.treeSetData1.addList.push(nodeObj)
      const data = Object.assign({
        gwid: nodeObj.id,
        gwmc: nodeObj.name,
        isEdit: nodeObj.isEdit,
        children: nodeObj.children
      })
      this.savePost(data)
      this.PosttreeQuery()
    },
    allowDrop1 (draggingNode, dropNode, type) {
      if (dropNode.data.gwid === 1) {
        return false
      } else {
        return true
      }
    },
    allowDrag1 (draggingNode) {
      // 顶层默认分组不允许拖拽
      if (draggingNode.data.gwid === 1) {
        return false
      } else {
        return true
      }
    },
    // 添加岗位
    append1 (node, data) {
      let gwid = 1000
      const newChild = {
        gwid: gwid++,
        isEdit: 0,
        gwmc: '添加新节点',
        // sjbm: data.bmdj,
        children: []
      }
      if (!data.children) {
        this.$set(data, 'children', [])
      }
      data.children.push(newChild)
      // this.saveDep(newChild)
    },
    // 编辑岗位
    edit1 (node, data) {
      this.$set(data, 'isEdit', 1)
      this.newApiGroupName = data.gwmc
      this.$nextTick(() => {
        this.$refs.input.focus()
      })
      // console.log('after:', data.gwid, data.gwmc, data.isEdit)
    },
    // 判断编辑框是否修改
    submitEdit1 (node, data) {
      if (data.gwmc === this.newApiGroupName) {
        // console.log('没有修改')
        this.newApiGroupName = ''
        this.$set(data, 'isEdit', 0)
      } else {
        this.$set(data, 'gwmc', this.newApiGroupName)
        this.newApiGroupName = ''
        this.$set(data, 'isEdit', 0)
        this.savePost(data)
      }
    },
    // 保存编辑后的的岗位
    savePost (data) {
      this.$confirm('确认提交吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = Object.assign({}, data)
        user.savePost(params).then(res => {
          if (res.code === 200) {
            this.$message({ message: '添加成功', type: 'success' })
          } else {
            this.$message({ message: '操作失败, ' + res.msg, type: 'error' })
          }
          this.PosttreeQuery()
        })
      })
    },
    // 删除岗位
    remove1 (node, data) {
      const parent = node.parent
      const children = parent.data.children || parent.data
      const index = children.findIndex(d => d.gwid === data.gwid)
      children.splice(index, 1)
      this.removePost(data)
    },
    removePost (data) {
      this.$confirm('确定需要删除选中岗位吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          gwid: data.gwid
        }
        user.removePost(params).then(res => {
          if (res.code === 200) {
            this.$message({ message: '删除成功', type: 'success' })
          } else {
            this.$message({ message: '操作失败, ' + res.msg, type: 'error' })
          }
          this.PosttreeQuery()
        })
      })
    },
    // 显示新增界面
    handleAdd: function () {
      this.editDialogVisible = true
      this.operation = true
      this.dataForm = {
        bmid: '',
        gwid: '',
        bmmc: '',
        gwmc: '',
        yhzh: '',
        yhmc: '',
        yhmm: '',
        email: '',
        lxdh: '',
        xb: ''
      }
      this.dataForm.bmid = '1'
      this.bmmc = '公司'
      this.dataForm.gwid = ''
      this.gwmc = ''
      this.yhzh = ''
      this.diasabledInput = false
    },
    // 显示编辑界面
    handleUpdate: function ($index, row) {
      this.editDialogVisible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.diasabledInput = true
        this.operation = false
        this.dataForm = Object.assign({}, row)
        this.dataForm.bmid = row.bmid
        this.bmmc = row.bmmc
        this.dataForm.gwid = row.gwid
        this.gwmc = row.gwmc
        this.dataForm.xb = row.xbid
        this.xb = row.xb
      })
    },
    // 选择某个部门
    handleNodeClick1 (bmdata) {
      // console.log(bmdata)
      this.bmmc = bmdata.bmmc
      this.dataForm.bmid = bmdata.bmid
      // console.log(this.dataForm.bmid)
      this.$refs.selectBmid1.blur()
    },
    // 选择某个岗位
    handleNodeClick2 (gwdata) {
      // console.log(data)
      this.gwmc = gwdata.gwmc
      this.dataForm.gwid = gwdata.gwid
      this.$refs.selectGwid.blur()
    },
    // 选择某个部门
    handleNodeClick3 (bmdata) {
      // console.log(bmdata)
      this.bmmc = bmdata.bmmc
      this.form.bmid = bmdata.bmid
      this.$refs.selectBmid3.blur()
    },
    // 选择某个岗位
    handleNodeClick4 (gwdata) {
      // console.log(gwdata)
      this.gwmc = gwdata.gwmc
      this.form.gwid = gwdata.gwid
      this.$refs.selectGwid.blur()
    },
    // 保存用户信息
    save () {
      this.$refs.dataForm.validate(valid => {
        if (valid) {
          if (
            !this.dataForm.yhmc ||
            this.dataForm.yhmc.replace(/\s*/g, '') === ''
          ) {
            this.$message.warning('考生姓名不能为空！')
            return
          } else {
            this.dataForm.yhmc = this.dataForm.yhmc.replace(/\s*/g, '')
          }
          this.$confirm('确认提交吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const params = Object.assign({}, this.dataForm)
            user.save(params).then(res => {
              if (res.code === 200) {
                this.$message({ message: '提交成功', type: 'success' })
                this.editDialogVisible = false
                this.$refs.dataForm.resetFields()
              } else {
                this.$message({
                  message: '操作失败, ' + res.msg,
                  type: 'error'
                })
              }
              this.query(null)
            })
          })
        }
      })
    },
    // 删除用户信息
    handleRemove ($index, row) {
      // console.log(row.yhid)
      this.$confirm('确定需要删除选中用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: row.yhid
        }
        user.remove(params).then(res => {
          this.$http.callback(res, () => {
            if (res.code === 200) {
              this.$message({ message: '删除成功', type: 'success' })
              this.editDialogVisible = false
              this.$refs.dataForm.resetFields()
            } else {
              this.$message({ message: '操作失败, ' + res.msg, type: 'error' })
            }
            this.query(this.currentPage)
          })
        })
      })
    },
    // 复选框选中状态改变
    handleSelectionChange (row) {
      // console.log(row)
      this.lshStr = ''
      row.forEach((value, index) => {
        if (index === 0) {
          this.lshStr += value.yhid
          // console.log(value.yhid)
        } else {
          this.lshStr += ',' + value.yhid
        }
      })
      if (this.lshStr.length === 0) {
      }
    },
    // 批量删除用户
    handleRemoveAll () {
      // console.log(this.lshStr)
      this.$confirm('确定需要删除选中用户吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          id: this.lshStr
        }
        user.removeall(params).then(res => {
          this.$http.callback(res, () => {
            if (res.code === 200) {
              this.$message({ message: '删除成功', type: 'success' })
              this.editDialogVisible = false
              this.$refs.dataForm.resetFields()
            } else {
              this.$message({ message: '操作失败, ' + res.msg, type: 'error' })
            }
            this.query(this.currentPage)
          })
        })
      })
    },
    handleksfx ($index, row) {
      const yhid = row.yhid
      this.$router.push({
        path: '/report/ksfx?' + 'yhid=' + yhid
      })
    },
    // 默认清空高级筛选数据
    clearHandle () {
      this.querydialogVisible = true
    },
    clearGjsc () {
      this.form.bmid = null
      this.bmmc = ''
      this.form.gwid = null
      this.gwmc = ''
      this.form.yhmc = ''
      this.form.email = ''
    },

    // 清空高级筛选部门数据
    handleBmClear () {
      this.bmid = ''
      this.bmmc = ''
    },
    // 清空高级筛选岗位数据
    handleGwClear () {
      this.gwid = ''
      this.gwmc = ''
    }
  },
  mounted () {
    // 进入页面后进行查询
    this.query()
    // 获取部门列表
    getDeptList().then(res => {
      this.$http.callback(res, () => {
        // 生成部门树
        this.parseDeptList(res.data)
      })
    })
    // 获取岗位列表
    getPostList().then(res => {
      this.$http.callback(res, () => {
        // 生成岗位树
        this.parsePostList(res.data)
      })
    })
  }
}
</script>
<style lang="less" scoped>
.button_color {
  border-color: #00f;
  color: #00f;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 20px;
}
.formItem {
  margin-left: 10px;
}
.gjsx-dialog /deep/ .el-dialog__body {
  overflow: inherit;
}
</style>
